const filters = state => state.filters
const changing = state => state.changing

export default {
    filters,
    changing
}
